import { format } from "date-fns";

export const EventoFecha = (fechas) => {
  let now = new Date();

  const proximaFecha = fechas.find((fecha) => new Date(fecha.fecha) >= now);
  if (!proximaFecha || proximaFecha == undefined) {
    return fechas[0];
  }
  return proximaFecha;
};
